"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Az = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1200 600", ...props },
    react_1.default.createElement("path", { fill: "#3f9c35", d: "M0 0h1200v600H0z" }),
    react_1.default.createElement("path", { fill: "#ed2939", d: "M0 0h1200v400H0z" }),
    react_1.default.createElement("path", { fill: "#00b9e4", d: "M0 0h1200v200H0z" }),
    react_1.default.createElement("circle", { cx: 580, cy: 300, r: 90, fill: "#fff" }),
    react_1.default.createElement("circle", { cx: 600, cy: 300, r: 75, fill: "#ed2939" }),
    react_1.default.createElement("path", { fill: "#fff", d: "m680 250 9.567 26.903 25.788-12.258-12.258 25.788L730 300l-26.903 9.567 12.258 25.788-25.788-12.258L680 350l-9.567-26.903-25.788 12.258 12.258-25.788L630 300l26.903-9.567-12.258-25.788 25.788 12.258L680 250z" })));
exports.default = Az;
//# sourceMappingURL=Az.js.map